export const STATO_COLORS = {
  lead: "bg-slate-100 text-slate-700 border-slate-300",
  mandato_inviato: "bg-blue-50 text-blue-700 border-blue-200",
  mandato_firmato: "bg-indigo-50 text-indigo-700 border-indigo-200",
  documenti_raccolti: "bg-sky-50 text-sky-800 border-sky-200",
  istanza_presentata: "bg-amber-50 text-amber-800 border-amber-300",
  in_attesa_consap: "bg-yellow-50 text-yellow-800 border-yellow-300",
  somme_incassate: "bg-emerald-50 text-emerald-800 border-emerald-300",
  compenso_trattenuto: "bg-teal-50 text-teal-800 border-teal-300",
  cliente_saldato: "bg-green-100 text-green-900 border-green-300",
  chiusa: "bg-slate-200 text-slate-600 border-slate-300",
};

export const STATI = [
  ["lead", "Lead"], ["mandato_inviato", "Mandato inviato"], ["mandato_firmato", "Mandato firmato"],
  ["documenti_raccolti", "Documenti raccolti"], ["istanza_presentata", "Istanza presentata"], ["in_attesa_consap", "In attesa Consap"],
  ["somme_incassate", "Somme incassate"], ["compenso_trattenuto", "Compenso trattenuto"], ["cliente_saldato", "Cliente saldato"], ["chiusa", "Chiusa"],
];
export const STATO_LABEL = Object.fromEntries(STATI);

export const MATCH_LABEL = { found: "Match", possible: "Possibile", not_found: "Nessun match", unavailable: "Consap non raggiungibile" };
export const MATCH_COLORS = {
  found: "bg-emerald-50 text-emerald-700 border-emerald-200",
  possible: "bg-amber-50 text-amber-700 border-amber-200",
  not_found: "bg-slate-50 text-slate-500 border-slate-200",
  unavailable: "bg-red-50 text-red-700 border-red-200",
};

export const ROLE_LABEL = { admin: "Avvocato titolare", collaboratore: "Collaboratore", segretaria: "Segretaria" };

export const StatoBadge = ({ s }) => (
  <span data-testid={`status-badge-${s}`} className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[11px] font-semibold whitespace-nowrap ${STATO_COLORS[s]}`}>{STATO_LABEL[s]}</span>
);

export const MatchBadge = ({ m }) => {
  const s = m?.status || "not_found";
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[11px] font-semibold whitespace-nowrap ${MATCH_COLORS[s]}`}>{MATCH_LABEL[s]}{m?.score ? ` · ${m.score}` : ""}</span>;
};

export const PageTitle = ({ title, sub, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
    <div><h1 className="font-serif text-4xl text-navy">{title}</h1>{sub && <p className="text-sm text-slate-500 mt-1">{sub}</p>}</div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Panel = ({ title, action, children, className = "", testid }) => (
  <section data-testid={testid} className={`bg-white border border-slate-200 rounded-xl ${className}`}>
    {title && <header className="flex items-center justify-between px-5 py-3.5 border-b border-slate-100"><h2 className="font-serif text-xl text-navy">{title}</h2>{action}</header>}
    <div className="p-5">{children}</div>
  </section>
);
